import React from 'react';
import styled from 'styled-components';
import CheckIcon from 'web-ui-kit/assets/CheckIcon';
import ClockIcon from 'web-ui-kit/assets/ClockIcon';
import MadeToOrderIcon from 'web-ui-kit/assets/MadeToOrderIcon';
import { textPrimaryM, successM } from 'web-ui-kit/colors';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';
import { Header5LargeStyles, BodySmallStyles } from 'web-ui-kit/typography';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function Availability(_ref) {
  var _ref$product = _ref.product,
      product = _ref$product === void 0 ? {} : _ref$product,
      _ref$wppUiMessaging = _ref.wppUiMessaging,
      wppUiMessaging = _ref$wppUiMessaging === void 0 ? null : _ref$wppUiMessaging; // uiMessaging gql is wrapped in FF, and contains the latest product CTA messaging.

  var _product$availability = product.availabilityV2,
      availabilityV2 = _product$availability === void 0 ? {} : _product$availability,
      _product$uiMessaging = product.uiMessaging,
      uiMessaging = _product$uiMessaging === void 0 ? {} : _product$uiMessaging;
  var estimatedDeliveryMsg = availabilityV2.estimatedDeliveryMsg,
      specialMessaging = availabilityV2.specialMessaging,
      status = availabilityV2.status; // uiMessaging, coming in from NextJS, will be undefined if coming from WPP.

  var uiMessagingBoth = wppUiMessaging || uiMessaging;
  var ctaTitle = uiMessagingBoth.ctaTitle,
      ctaMessage = uiMessagingBoth.ctaMessage;
  var statusOutOfStock = ctaTitle ? ctaTitle === 'Currently Unavailable' : status === 'OUT_OF_STOCK';
  var statusDiscontinued = ctaTitle ? ctaTitle === 'Discontinued' : status === 'DISCONTINUED';
  var isUnavailable = statusOutOfStock || statusDiscontinued;
  var statusTitle = ctaTitle || copy.toStatusString(status);
  var deliveryMessage = ctaMessage || estimatedDeliveryMsg || unavailableMsg.toMsgString(statusTitle, isUnavailable);
  var isRepeatedMessage = deliveryMessage.includes(COMPARABLE_ITEMS_TEXT) && specialMessaging.includes(COMPARABLE_ITEMS_TEXT);
  var Container = styles.Container,
      EstimatedDelivery = styles.EstimatedDelivery,
      StatusIconWrapper = styles.StatusIconWrapper,
      StatusTitleWrapper = styles.StatusTitleWrapper,
      SpecialMessaging = styles.SpecialMessaging,
      StatusContainer = styles.StatusContainer;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "availability"
    }, !isUnavailable &&
    /*#__PURE__*/
    React.createElement(StatusContainer, null,
    /*#__PURE__*/
    React.createElement(StatusIconWrapper, null, statusIcon.toStatusIcon(statusTitle)),
    /*#__PURE__*/
    React.createElement(StatusTitleWrapper, {
      status: statusTitle
    }, statusTitle)),
    /*#__PURE__*/
    React.createElement(EstimatedDelivery, null, deliveryMessage), !isRepeatedMessage &&
    /*#__PURE__*/
    React.createElement(SpecialMessaging, null, specialMessaging))
  );
}

var COMPARABLE_ITEMS_TEXT = 'Check out the alternative products below for comparable items.';
var copy = {
  toStatusString: function toStatusString(status) {
    switch (status) {
      case 'BACKORDERED':
        return 'Backordered';

      case 'DISCONTINUED':
        return 'Discontinued';

      case 'IN_STOCK':
        return 'In Stock';

      case 'MADE_TO_ORDER':
        return 'Made to Order';

      case 'OUT_OF_STOCK':
        return 'Currently Unavailable';

      default:
        return '';
    }
  }
};
var statusIcon = {
  toStatusIcon: function toStatusIcon(statusTitle) {
    switch (statusTitle) {
      case 'Backordered':
        return (
          /*#__PURE__*/
          React.createElement(ClockIcon, null)
        );

      case 'Made to Order':
        return (
          /*#__PURE__*/
          React.createElement(MadeToOrderIcon, null)
        );

      case 'In Stock':
        return (
          /*#__PURE__*/
          React.createElement(CheckIcon, {
            size: 16,
            variant: "success"
          })
        );

      default:
        return '';
    }
  }
};
var unavailableMsg = {
  toMsgString: function toMsgString(statusTitle, isUnavailable) {
    switch (statusTitle) {
      case 'Currently Unavailable':
        return "Sorry we\u2019re currently out of this item. ".concat(COMPARABLE_ITEMS_TEXT);

      case 'Discontinued':
        return "Sorry this item is no longer offered. ".concat(COMPARABLE_ITEMS_TEXT);

      default:
        return '';
    }
  }
};
var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n\n    ", " {\n      padding: 1.5rem 0 1rem 0;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  StatusContainer: styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.125rem;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "])), Header5LargeStyles),
  StatusIconWrapper: styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    margin-right: 0.375rem;\n  "]))),
  StatusTitleWrapper: styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n    ", "\n  "])), textPrimaryM, function (p) {
    return p.status === 'In Stock' && "color: ".concat(successM, ";");
  }),
  EstimatedDelivery: styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.25rem;\n  "])), BodySmallStyles),
  SpecialMessaging: styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", ";\n  "])), BodySmallStyles)
};
export default Availability;